import React from 'react';
import styled from 'styled-components';
import { Translate } from '@bynder/localization';
import { token } from '@bynder/design-system';
import SkeletonElement from '../shared/styled-components/SkeletonElement';
import {
  useCurrentUserIdentity,
  useUserIdentity,
} from '../../queries/identity';

interface Props {
  authorId: string;
}

const GuideOwner: React.FC<Props> = ({ authorId }) => {
  const { data: currentUser, isLoading: isLoadingCurrentUser } =
    useCurrentUserIdentity();
  const {
    data: owner,
    isLoading: isLoadingOwner,
    isError,
  } = useUserIdentity(authorId);

  if (isLoadingCurrentUser || isLoadingOwner || !owner || !currentUser) {
    return <SkeletonElement height={14} width={100} />;
  } else if (isError) {
    return (
      <StyledGuideOwner>
        <Translate id="GUIDE_OWNER.AUTHOR_UNKNOWN" />
      </StyledGuideOwner>
    );
  } else if (owner.id === currentUser.id) {
    return (
      <StyledGuideOwner>
        <Translate id="GUIDE_OWNER.CREATED_BY_YOU" />
      </StyledGuideOwner>
    );
  }

  return (
    <StyledGuideOwner>
      <Translate id="GUIDE_OWNER.CREATED_BY" author={owner.full_name ?? ''} />
    </StyledGuideOwner>
  );
};

export const StyledGuideOwner = styled.div`
  font-size: ${token.fontSize75};
`;

export default GuideOwner;
